import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import ItemChoiceItemDisplay from "./ItemChoiceItemDisplay";

function ItemChoiceModal(props) {
  let ItemList = [];
  for (const [index, value] of props.choices.entries()) {
    ItemList.push(
      <Col key={index}>
        <ItemChoiceItemDisplay
        key={index}
        index={index}
        item={value}
        addToInventory={props.addToInventory}
        showItemChoiceModal={props.showItemChoiceModal}
        />
      </Col>
    );
  }

  return(
    <Modal 
      show={props.showItemChoiceModal} 
      onHide={() => props.hideItemChoiceModal()}
      backdrop="static"
      keyboard={false}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title>Choose One:</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row> {ItemList} </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => props.hideItemChoiceModal()}>
          Skip...
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ItemChoiceModal;
